import { ConfigData } from "@happy-legal/graphql-types";
import { createContext, ReactNode } from "react";
import { MUTATION_SET_CONFIG_DATA } from "../gql/mutations";
import { configDataReducer, TConfigDataAction } from "../reducer";
import { createProvider, IObjectContextType } from "./ProviderFactory";

export const ConfigDataContext = createContext<
  IObjectContextType<ConfigData, TConfigDataAction>
>(undefined!);
// TODO: https://www.rivoltafilippo.com/typing-react-context-to-avoid-an-undefined-default-value

ConfigDataContext.displayName = "Config Data Context";

export const configDataInitState = {
  id: "",
  data: [],
  publicAccess: null,
};

const ConfigDataProvider = ({ children }: { children: ReactNode }) =>
  createProvider(
    ConfigDataContext,
    configDataReducer,
    configDataInitState,
    children,
    MUTATION_SET_CONFIG_DATA
  );

export default ConfigDataProvider;
